import "@fontsource/space-grotesk";
import "@fontsource/jetbrains-mono";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";

import NavBar from "./components/layout/NavBar";
import Footer from "./components/layout/Footer";
import RevealSection from "./components/layout/RevealSection";
import Hero from "./components/hero/Hero";
import Stats from "./components/stats/Stats";
import technologies from "./data/technologies";
import ExperienceCerts from "./components/experience/ExperienceCerts";
import Contacts from "./components/contact/Contacts";
import Technologies from "./components/technologies/Technologies";
import stats from "./data/stats";
import experiences from "./data/experiences";
import certifications from "./data/certifications";
import languages from "./data/languages";
import contacts from "./data/contacts";
import Projects from "./components/projects/Projects";
import projects from "./data/projects";

export default function App() {
  return (
    <>
      <NavBar />
      <main>
        <Hero />
        <RevealSection>
          <Stats stats={stats} />
        </RevealSection>
        <RevealSection>
          <Technologies technologies={technologies} />
        </RevealSection>

        <RevealSection>
          <Projects projects={projects} />
        </RevealSection>
        <RevealSection>
          <ExperienceCerts
            experiences={experiences}
            certifications={certifications}
            languages={languages}
          />
        </RevealSection>
        <RevealSection>
          <Contacts contacts={contacts} />
        </RevealSection>
      </main>

      <Footer />
    </>
  );
}
